import React from "react";
import { Link } from "react-router-dom";
import { HiOutlineX } from "react-icons/hi";

const PaNavigationContextBanner = ({
  title,
  description = null,
  backTo = "/dashboard",
  backLabel = "Back to dashboard",
  onDismiss = null,
}) => {
  if (!title) {
    return null;
  }

  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50/80 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-indigo-950">{title}</p>
          {description ? (
            <p className="mt-1 text-sm text-indigo-900/80">{description}</p>
          ) : null}
          {backTo ? (
            <Link
              to={backTo}
              className="mt-2 inline-block text-xs font-medium text-indigo-700 hover:text-indigo-800"
            >
              ← {backLabel}
            </Link>
          ) : null}
        </div>
        {onDismiss ? (
          <button
            type="button"
            onClick={onDismiss}
            className="shrink-0 rounded p-1 text-indigo-700 hover:bg-indigo-100"
            aria-label="Dismiss context"
          >
            <HiOutlineX className="h-4 w-4" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PaNavigationContextBanner;
